var exports = {
  "e": "xe533113f--67fdf1--fullscreen-panorama",
};

module.exports = exports;
